var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.2C6 0.537281 6.53728 0 7.2 0H22.8C23.4627 0 24 0.537281 24 1.2C24 1.86272 23.4627 2.4 22.8 2.4H7.2C6.53728 2.4 6 1.86267 6 1.2V1.2ZM22.8 7.2H1.2C0.537281 7.2 0 7.73733 0 8.4C0 9.06272 0.537281 9.6 1.2 9.6H22.8C23.4627 9.6 24 9.06272 24 8.4C24 7.73733 23.4627 7.2 22.8 7.2ZM22.8 14.4H12C11.3373 14.4 10.8 14.9373 10.8 15.6C10.8 16.2627 11.3373 16.8 12 16.8H22.8C23.4627 16.8 24 16.2627 24 15.6C24 14.9373 23.4627 14.4 22.8 14.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.a44c6411a3c819d600f321ee8e9d7e68.svg";
export { ForwardRef as ReactComponent };